/* eslint-disable react/jsx-key */
"use client";

import React, { useEffect } from "react";
import PortfolioColorscheme from "@/app/components/PortfolioColorscheme/PortfolioColorscheme";
import PortfolioResponsiveDisplays from "@/app/components/PortfolioResponsiveDisplays/PortfolioResponsiveDisplays";
import PortfolioTypography from "@/app/components/PortfolioTypography/PortfolioTypography";
import WebsiteLogo from "@/app/components/WebsiteLogo/websitelogo";
import { WebsiteSubtitle } from "@/app/components/WebsiteSubtitle/WebsiteSubtitle";
import PortfolioTechStack from "@/app/components/PortfolioTechStack/PortfolioTechStack";
import FigmaLogo from "@/app/components/icons/figmaLogo";
import HTML5Logo from "@/app/components/icons/HTML5Logo";
import CSS3Logo from "@/app/components/icons/CSS3Logo";
import JSLogo from "@/app/components/icons/JSLogo";
import LiquidLogo from "@/app/components/icons/liquidLogo";
import ShopifyLogo from "@/app/components/icons/ShopifyLogo";
import AboutIntroducionSection from "@/components/common/FirstBlockAbout";

export default function BlondHaus() {
  const primaryColor = "#2c2d2c";

  useEffect(() => {
    const link = document.createElement("link");
    link.href =
      "https://fonts.googleapis.com/css2?family=Josefin+Sans:ital,wght@0,100..700;1,100..700&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  return (
    <>
      <section className="flex flex-col gap-[100px] my-[35px]">
        <div>
          <WebsiteLogo imageSrc="https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FBlondhaus%2Fblondhaus%20logo.webp?alt=media&token=5af17cb3-d078-4283-9614-b4f9836f2930" />
          <AboutIntroducionSection
            media={{
              type: "image",
              src: "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FBlondhaus%2Fblondhaus%20background.webp?alt=media&token=b4963fc3-b1f1-4b22-81f6-770a195e742f",
            }}
            primaryColor={primaryColor}
          />
          <WebsiteSubtitle
            text="For BlondHaus, a salon that views hair as a canvas and stylists as artists, we developed a sophisticated online presence to match their creative philosophy and cater to their clients' comprehensive hair care needs. Our work involved crafting a custom Shopify theme, handling the full design and development to create a seamless experience for booking services and shopping for premium hair products. We also managed the product filling for their e-commerce store and implemented SEO strategies to enhance their visibility, ensuring clients can easily connect with their artistic services and curated products, leaving them looking and feeling their best."
            title="Deliverables"
            tags={["TYPOGRAPHY", "COLORSCHEME", "RESPONSIVE DESIGN", "TECH STACK"]}
            buttonHref="https://blondhaus.ca"
          />
        </div>

        <PortfolioTypography
          typographyData={[
            {
              headline: "Excellence in Cleaning Services: delivering unmatched quality and meticulous attention to detail.",
              fontFamily: "Josefin Sans",
              fontSize: "42px",
              letterSpacing: "0%",
              lineHeight: "48px",
              textColor: "#2c2d2c",
            },
          ]}
          primaryColor={primaryColor}
        />
        <PortfolioColorscheme
          ColorschemeData={[
            {
              title: "Main color",
              color: "#2C2D2C",
              rgb: "#2C2D2C",
              textColor: "#FFFFFF",
            },
            {
              title: "White",
              color: "#FFFFFF",
              rgb: "#FFFFFF",
              textColor: "#2c2d2c",
            },
            {
              title: "Light Gray",
              color: "#EAEAEA",
              rgb: "#EAEAEA",
              textColor: "#2c2d2c",
            },
          ]}
          primaryColor={primaryColor}
        />
        <PortfolioResponsiveDisplays
          ResponsiveDisplaysData={[
            {
              type: "image",
              content:
                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FBlondhaus%2Fblondhauspc.webp?alt=media&token=3312c58d-03b2-4e34-b433-65af8b6f0c75",
            },
            {
              type: "image",
              content:
                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FBlondhaus%2Fblondhausipad.webp?alt=media&token=305e3a8e-b7b1-4dad-b1ad-76f5591d973b",
            },
            {
              type: "image",
              content:
                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FBlondhaus%2Fblondhausmobile.webp?alt=media&token=f0deb992-4e17-4f17-941a-e5b7ea36a005",
            },
          ]}
          primaryColor={primaryColor}
        />
        <PortfolioTechStack
          primaryColor={primaryColor}
          blocks={[
            {
              title: "Design",
              titleColor: "#2c2d2c",
              icons: [<FigmaLogo />],
              opacity: 5,
            },
            {
              title: "Layout Development",
              titleColor: "#2c2d2c",
              icons: [<HTML5Logo />, <CSS3Logo />, <JSLogo />],
              opacity: 15,
            },
            {
              title: "Theme Development",
              titleColor: "#2c2d2c",
              icons: [<LiquidLogo />],
              opacity: 25,
            },
            {
              title: "Publishing",
              titleColor: "#2c2d2c",
              icons: [<ShopifyLogo />],
              opacity: 30,
            },
          ]}
        />
      </section>
    </>
  );
}
